import { AxiosStatic, AxiosError } from "axios";
import * as moment from "moment";

import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import {
    MyResultTableEntryModel,
    ManagerSraQuestionnaireResultModel,
    TeamSraQuestionnaireResultModel
} from "@teamprevent/common/stressRiskAssessment/models";

export class SraApi {
    private readonly apiUrl = "/api/stressriskassessment";

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async submit(questions: AnsweredQuestionWithId[]): Promise<void> {
        await this.axios.post(`${this.apiUrl}`, { questions });
    }

    public async resendCompletionRequest(sraManagerSectionId: string): Promise<void> {
        await this.axios.post(`${this.apiUrl}/resend/${sraManagerSectionId}`);
    }

    public async loadSraTasks(): Promise<MyResultTableEntryModel[]> {
        const response = await this.axios.get(`${this.apiUrl}/getSraTasks`);
        return response.data as MyResultTableEntryModel[];
    }

    public async loadSraResults(sraEmployeeSectionId: string): Promise<ManagerSraQuestionnaireResultModel> {
        try {
            const response = await this.axios.get<ManagerSraQuestionnaireResultModel>(
                `${this.apiUrl}/getSraResults/${sraEmployeeSectionId}`);
            return this.parseManagerSraQuestionnaireResultModel(response.data);
        } catch (exception) {
            const axiosError = exception as AxiosError;
            if (axiosError.response && axiosError.response.status && axiosError.response.status === 404) {
                return null;
            }

            throw axiosError;
        }
    }

    public async loadSraResultsForCase(caseId: string): Promise<ManagerSraQuestionnaireResultModel> {
        try {
            const response = await this.axios.get<ManagerSraQuestionnaireResultModel>(
                `${this.apiUrl}/getSraResultsForCase/${caseId}`);
            return this.parseManagerSraQuestionnaireResultModel(response.data);
        } catch (exception) {
            const axiosError = exception as AxiosError;
            if (axiosError.response && axiosError.response.status && axiosError.response.status === 404) {
                return null;
            }

            throw axiosError;
        }
    }

    public async loadTeamSraResults(departmentId?: string): Promise<TeamSraQuestionnaireResultModel> {
        try {
            const response = await this.axios.get<TeamSraQuestionnaireResultModel>(`${this.apiUrl}/getTeamSraResults/${departmentId}`);
            return response.data;
        } catch (exception) {
            const axiosError = exception as AxiosError;
            if (axiosError.response && axiosError.response.status && axiosError.response.status === 404) {
                return null;
            }

            throw axiosError;
        }
    }

    private parseManagerSraQuestionnaireResultModel(model: ManagerSraQuestionnaireResultModel): ManagerSraQuestionnaireResultModel {
        return { ...model, dateCompleted: model.dateCompleted && moment(model.dateCompleted) };
    }
}
